import config from 'config'

export const casaTurnedoffFeatures = config.turnedoffFeatures;



// WEBPACK FOOTER //
// ./src/configs/casa-features.js